export const AUTHOR_PUBLISH = "publishAuthor";
export const AUTHOR_DELETE = "deleteAuthor";
export const AUTHOR_RESET_STATE = "resetAuthorState";
export const AUTHOR_EDIT = "editAuthor";

export const ARTICLE_PUBLISH = "publishArticle";
export const ARTICLE_DELETE = "deleteArticle";
export const ARTICLE_EDIT = "editArticle";
export const ARTICLE_RESET_STATE = "resetArticleState"

export const BOOK_PUBLISH = "publishBook";
export const BOOK_DELETE = "deleteBook";
export const BOOK_EDIT = "editBook";
export const BOOK_RESET_STATE = "resetBookState"

export const CONTENT_PUBLISH = "publishVariant";
export const CONTENT_DELETE = "deleteVariant";
export const CONTENT_EDIT = "editVariant";
export const CONTENT_RESET_STATE = "resetVariantState"

export const MANUFACTURER_PUBLISH = "publishManufacturer";
export const MANUFACTURER_DELETE = "deleteManufacturer";
export const MANUFACTURER_EDIT = "editManufacturer";
export const MANUFACTURER_RESET_STATE = "resetManufacturerState"

export const MODEL_PUBLISH = "publishModel";
export const MODEL_DELETE = "deleteModel";
export const MODEL_EDIT = "editModel";
export const MODEL_RESET_STATE = "resetModelState"

export const VARIANT_PUBLISH = "publishVariant";
export const VARIANT_DELETE = "deleteVariant";
export const VARIANT_EDIT = "editVariant";
export const VARIANT_RESET_STATE = "resetVariantState"

export const PRODUCT_PUBLISH = "publishProduct";
export const PRODUCT_DELETE = "deleteProduct";
export const PRODUCT_EDIT = "editProduct";
export const PRODUCT_RESET_STATE = "resetProductState"

export const CHECK_AUTH = "checkAuth";

export const FETCH_AUTHOR = "fetchAuthor";
export const FETCH_AUTHORS = "fetchAuthors";

export const FETCH_ARTICLE = "fetchArticle";
export const FETCH_ARTICLES = "fetchArticles";
export const FETCH_ARTICLES_COUNT = "fetchArticlesCount";
export const SEARCH_ARTICLES = "searchArticles";

export const FETCH_BLOG = "fetchBlog";
export const FETCH_BLOG_COUNT = "fetchBlogCount";

export const FETCH_BOOK = "fetchBook";
export const FETCH_BOOKS = "fetchBooks";
export const FETCH_BOOKS_COUNT = "fetchBooksCount";
export const SEARCH_BOOKS = "searchBooks";

export const FETCH_CONTENT = "fetchContent";
export const FETCH_CONTENTS = "fetchContents";

export const FETCH_MANUFACTURER = "fetchManufacturer";
export const FETCH_MANUFACTURERS = "fetchManufacturers";

export const FETCH_MODEL = "fetchModel";
export const FETCH_MODELS = "fetchModels";

export const FETCH_VARIANT = "fetchVariant";
export const FETCH_VARIANTS = "fetchVariants";

export const FETCH_PRODUCT = "fetchProduct";
export const FETCH_PRODUCTS = "fetchProducts";

export const FETCH_VIDEOS = "fetchVideos";
export const FETCH_VIDEOS_COUNT = "fetchVideosCount";

export const FETCH_SEARCH_TEXT = "fetchSearchText";

export const LOGIN = "login";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const UPDATE_USER = "updateUser";
